module.exports = __webpack_public_path__ + "img/logo.fd6ed9a4.png";